import { Box, Typography } from "@mui/material";
import { GridColumnHeaderParams } from "@mui/x-data-grid-premium";

export function DataGridHeaderCell (params: GridColumnHeaderParams) {

    return <Typography style={{ fontWeight: 'bold' }}>{params.colDef.headerName}</Typography>
}